import { render, staticRenderFns } from "./LabelLaudoRenovabio.vue?vue&type=template&id=39c2f67b&scoped=true&lang=pug"
import script from "./LabelLaudoRenovabio.vue?vue&type=script&lang=js"
export * from "./LabelLaudoRenovabio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c2f67b",
  null
  
)

export default component.exports